export default __webpack_public_path__ + "static/1914-95fabbfad6087eb311140922b129e2f0.gif";